import { Element } from 'slate';

function isElement(node) {
  return Element.isElement(node) && 'type' in node;
}

export { isElement };
